import {PLAY_MODE_ACTION} from "utils";

export const OPEN_METAVERSE_ABOUT = "about";

export const DEFAULT_BTN_LIST = [
  // PLAY_MODE_ACTION.SOUND,
  PLAY_MODE_ACTION.SELFIE,
  PLAY_MODE_ACTION.CHAT,
  PLAY_MODE_ACTION.QUICK_CHAT,
  // PLAY_MODE_ACTION.VOICE_CHAT,
];

export const OPEN_METAVERSE_BTN_LIST = [
  // PLAY_MODE_ACTION.QUICK_CHAT,
  PLAY_MODE_ACTION.SELFIE,
  OPEN_METAVERSE_ABOUT,
];
